import { render, staticRenderFns } from "./NavigationTabs.vue?vue&type=template&id=73faeddc&"
import script from "./NavigationTabs.vue?vue&type=script&lang=ts&"
export * from "./NavigationTabs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports